import styled from 'styled-components'

export const FloatingButton = styled.div`
	background-color: ${props => props.theme.colors.brand.lightBlue};
	display: ${({ $isMobile, $isOpen }) => ($isMobile && $isOpen ? 'none' : 'flex')};
	width: 184px;
	height: 35px;
	align-items: center;
	justify-content: center;
	transform: rotate(-90deg);
	position: fixed;
	right: ${({ $isOpen }) => ($isOpen ? '397px' : '-76px')};
	top: ${({ $isMobile }) => ($isMobile ? '50%' : '30%')};
	border-radius: 8px 8px 0px 0px;
	cursor: pointer;
	z-index: 10;
	transition: 0.5s;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		right: ${({ $isOpen }) => ($isOpen ? '397px' : '-80px')};
	}
`

export const ButtonText = styled.p`
	color: ${props => props.theme.colors.brand.white};
	font-size: 14px;
	font-weight: 600;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		padding-bottom: 4px;
	}
`

export const Panel = styled.div`
	display: flex;
	flex-direction: column;
	position: fixed;
	right: 0;
	top: 0;
	width: ${({ $isOpen, $isMobile }) => ($isOpen ? ($isMobile ? '100vw' : '471px') : '0')};
	height: 100vh;
	padding-top: 3rem;
	background-color: ${props => props.theme.colors.brand.white};
	transition: width 0.5s;
	overflow: hidden;
	z-index: ${({ $isOpen }) => ($isOpen ? 1002 : 0)};
`

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.4);
	opacity: 0;
	transition: opacity 0.5s;
	pointer-events: none;
	z-index: 1001;
	${({ $isOpen }) =>
		$isOpen &&
		`
		opacity: 1;
		pointer-events: all;
	`}
`

export const Header = styled.div`
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 56px;
		background-color: ${props => props.theme.colors.brand.white};
		z-index: 1;
	}
`



export const CloseButton = styled.button`
	background-color: transparent;
	border: none;
	position: absolute;
	padding: 0;
	top: 24px;
	right: 24px;
	color: ${props => props.theme.colors.text.secondaryText};
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		top: 50%;
		right: 16px;
		transform: translateY(-50%);
	}
`
